import { defineComponent as _defineComponent } from 'vue'
import CInput from '@/components/shared/CInput';
import CButtonGroup, { type CButtonGroupItem } from '@/components/shared/CButtonGroup';
import CalendarFieldTitle from './CalendarFieldTitle.vue';
import CalendarTitleStyleFields from './CalendarTitleStyleFields.vue';
import { normalizeCommaList } from './calendarUtils';
import { useCalendarConfig } from './useCalendarConfig';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import type { CalendarConfig } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'MonthYearProperties',
  props: {
    imageElement: null
  },
  emits: ["update-config"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update-config', config: Partial<CalendarConfig>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    imageElement?: ImagePlaceholderElement;
};

const STYLING_MODES: CButtonGroupItem<boolean>[] = [
    { label: 'Combined Styling', value: true },
    { label: 'Separate Styling', value: false }
];

// Vue 2.7 SFC compiler cannot resolve imported types in defineProps



const { config, elementKey, disabled, update } = useCalendarConfig(props, emit);

const onStylingModeChange = (combined: boolean) => {
    // Unset alignment renders on the right in the lib, left reads better as the separate mode starting point
    update({ yearMonthCombined: combined, ...(!combined && !config.value?.monthAlign && { monthAlign: 'start' }) });
};

const onMonthNamesChange = (value: string | number = '') => {
    const monthNames = normalizeCommaList(String(value));
    if (monthNames.split(',').length !== 12) return;
    update({ monthNames });
};

return { __sfc: true,STYLING_MODES, props, emit, config, elementKey, disabled, update, onStylingModeChange, onMonthNamesChange, CInput, CButtonGroup, CalendarFieldTitle, CalendarTitleStyleFields }
}

})